import { ShortcutsCheatSheetModal } from './ShortcutsCheatSheetModal';
import { useShortcutsCheatSheet } from './useShortcutsCheatSheet';

export const ShortcutsCheatSheet = () => {
  const { isOpen, close } = useShortcutsCheatSheet();

  return (
    <ShortcutsCheatSheetModal
      isOpen={isOpen}
      onClose={close}
    />
  );
};
